import * as React from "react";

import ComponentPage from "../../Components/ComponentPage";
import Usage from "../../Docs/Components/EditableDropdown/EditableDropdownUsage.mdx";

import Examples from "../../Docs/Components/EditableDropdown/EditableDropdownExamples";
        
class Page extends React.Component {
public render() {
    return (
        <ComponentPage
            name="Editable dropdown"
            description="EditableDropdowns allow selecting one item from a list that can be filtered."
            apiSources={["azure-devops-ui/Components/EditableDropdown/EditableDropdown.Props.d.ts", "azure-devops-ui/Components/ListBox/ListBox.Props.d.ts"]}
            examples={Examples}
            internalLinks={{"figma":"https://www.figma.com/file/dMVwHGDPtjpyUUDzsJ0x1tDY/Input-controls-draft?node-id=668%3A2105"}}
            status={{"design":"done","code":"done","docs":"done"}}
            usage={Usage}
        />
    );
}
}
        
export default Page;